export const GET_TOTAL_STATS = 'BTAX/get_total_stats';
export const GET_GRAPH_STATS = 'BTAX/get_graph_stats';
